import { Employee } from '@synergy/models';

/** Ä with A, case and accents aside, the way people read names (R-267). */
const collator = new Intl.Collator('de', { sensitivity: 'base' });

type Named = Pick<Employee, 'firstName' | 'lastName'>;

/**
 * Suppliers are addressed formally, members by first name (GF 30.10.2026,
 * R-267): a supplier's staff reads "Nachname, Vorname" and sorts by last name,
 * a member's staff reads "Vorname Nachname" and sorts by first name.
 */
export const supplierEmployeeName = (employee: Named): string =>
    [employee.lastName, employee.firstName].filter(Boolean).join(', ');

export const memberEmployeeName = (employee: Named): string =>
    [employee.firstName, employee.lastName].filter(Boolean).join(' ');

export const bySupplierEmployeeName = (a: Named, b: Named): number =>
    collator.compare(a.lastName ?? '', b.lastName ?? '') || collator.compare(a.firstName ?? '', b.firstName ?? '');

export const byMemberEmployeeName = (a: Named, b: Named): number =>
    collator.compare(a.firstName ?? '', b.firstName ?? '') || collator.compare(a.lastName ?? '', b.lastName ?? '');
